export const defaultBanners = [
  // { url: 'static/imgs/banner/01.png' },
  { url: 'static/imgs/banner/02.png' },
  { url: 'static/imgs/banner/03.png' }
]
export const baimaBanners = [
  { url: 'static/imgs/banner/baima_01.jpg' }
]
export const polyBanners = [
  { url: 'static/imgs/banner/poly_01.png' },
  { url: 'static/imgs/banner/poly_02.png' },
  { url: 'static/imgs/banner/poly_03.png' }
]
export const wzicecBanners = [
  { url: 'static/imgs/banner/wzicec_01.jpg' }
]



// WEBPACK FOOTER //
// ./src/common/Banner.js